import React from "react";
import Weather from "./Weather";
import "./App.css";


 export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Sao Paulo" />
        <footer>
          <a
            href="https://github.com/JulesAlves/Rainbow-Weather-Final"
            target="_blank"
            rel="noreferrer"
          >
            Open-source code{" "}
          </a>{" "}
          by Julia dos Santos Alves
        </footer>
      </div>
    </div>
  );
}